import GeomTool from "../geom/GeomTool";
import MathTool from "../math/MathTool";

export default class HairyTexture{
    constructor( width, height, numHairs, bgColor="#ffffff00", hairColor="#000000", hairWidth=1, hairLength=500 ){
        this.width = width;
        this.height = height;
        this.numHairs = numHairs ? numHairs : Math.sqrt(width*height)/hairLength;
        this.bgColor = bgColor;
        this.hairColor = hairColor;
        this.hairWidth = hairWidth;
        this.hairLength = hairLength;
        
        this.textureCanvas = p5App.createGraphics( width, height );
        this.textureCanvas.background( bgColor );
        this.canvas = p5App.createGraphics( width, height );
        this.mergerCanvas = p5App.createGraphics( width, height );

        /* const scale = 1;//window.devicePixelRatio; // Change to 1 on retina screens to see blurry canvas.
        this.textureCanvas.pixelDensity(scale);
        this.canvas.pixelDensity(scale);
        this.mergerCanvas.pixelDensity(scale); */

        /* this.textureCanvas.width = Math.floor(this.width * scale);
        this.textureCanvas.height = Math.floor(this.height * scale);        
        //this.textureCanvas.drawingContext.scale(scale, scale);      // Normalize coordinate system to use CSS pixels.
        
        this.canvas.width = Math.floor(this.width * scale);
        this.canvas.height = Math.floor(this.height * scale);        
        //this.canvas.drawingContext.scale(scale, scale);      // Normalize coordinate system to use CSS pixels.
        
        this.mergerCanvas.width = Math.floor(this.width * scale);
        this.mergerCanvas.height = Math.floor(this.height * scale);     */    
        //this.mergerCanvas.drawingContext.scale(scale, scale);      // Normalize coordinate system to use CSS pixels.

        this.updateTexture();
    }

    updateTexture(){
        let xOffset = MathTool.randInt(1000,-1000);
        let startX = xOffset>0 ? 0 : -xOffset;
        let endX = xOffset>0 ? this.width : this.width+Math.abs(xOffset);
        console.log( "HairyTexture::updateTexture: ", this.numHairs, " strokes" );
        this.textureCanvas.clear();
        this.textureCanvas.background( this.bgColor );
        for (let i = startX; i < endX; i+=this.numHairs) {
            /* let x0 = MathTool.randomInRange( this.width, 0 );
            let y0 = MathTool.randomInRange( this.height, 0 );

            let endPt = GeomTool.randomPointInCircumference( this.hairLength, x0, y0 ); */

            this.textureCanvas.push();
            //this.textureCanvas.clear();
            this.textureCanvas.noFill();
            this.textureCanvas.stroke( this.hairColor );
            this.textureCanvas.strokeWeight( this.hairWidth );
            let p0 = {
                x: xOffset>0 ? i : i-xOffset,
            }
            this.textureCanvas.line( i+MathTool.randomInRange(20,-20), 0, i+MathTool.randomInRange(20,-20)+xOffset, this.height );
            //this.textureCanvas.line( x0, y0, endPt.x, endPt.y );
            this.textureCanvas.pop();
        }
    }

    paintTo( ctx ){

        this.mergerCanvas.push();
        this.mergerCanvas.clear();
        this.mergerCanvas.image( this.canvas, 0, 0 );
        this.mergerCanvas.drawingContext.globalCompositeOperation = "source-in";
        this.mergerCanvas.image( this.textureCanvas, 0, 0 );
        this.mergerCanvas.drawingContext.globalCompositeOperation = "source-over";
        //this.mergerCanvas.drawingContext.getImageData( 0, 0, this.width, this.height );
        this.mergerCanvas.pop();
        ctx.image( this.mergerCanvas, 0, 0 );
        
    }
}